import { RefreshCw } from "lucide-react";

// 02.7-settings.md §5/paso b -- extraído de WhatsPanel.jsx. Puramente presentacional: solo lee
// `status`/`qrCodeData`/`qrProgress` por props, `onConnect` para el botón "Generar nuevo QR".
export default function WhatsConnectQrView({ status, qrCodeData, qrProgress, onConnect }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "var(--space-5)",
        textAlign: "center",
        flex: 1,
      }}
    >
      <div
        style={{
          marginBottom: "var(--space-5)",
          fontSize: "15px",
          color: "#555",
        }}
      >
        Conecta tu número personal para ver y responder a tus mensajes.
      </div>
      <div
        style={{
          width: "200px",
          height: "200px",
          borderRadius: "var(--radius-xl)",
          background: "#f0f2f5",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          border: "1px dashed #ccc",
          overflow: "hidden",
          position: "relative",
        }}
      >
        {qrCodeData ? (
          <>
            <img
              src={qrCodeData}
              alt="WhatsApp QR"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                background: "white",
              }}
            />
            <div style={{ width: "100%", height: "4px", background: "#e0e0e0", position: "absolute", bottom: 0, left: 0 }}>
              <div style={{ width: `${qrProgress}%`, height: "100%", background: "#00a884", transition: "width 0.1s linear" }} />
            </div>
          </>
        ) : (
          <>
            <RefreshCw
              size={32}
              color="#666"
              className="spin-animation"
            />
            <span
              style={{
                fontSize: "12px",
                color: "#666",
                marginTop: "var(--space-3)",
              }}
            >
              Generando QR...
            </span>
          </>
        )}
      </div>
      {status === "qr_ready" && (
        <button
          onClick={onConnect}
          style={{
            marginTop: "15px",
            padding: "var(--space-2) var(--space-4)",
            background: "#e0e0e0",
            border: "none",
            borderRadius: "var(--radius-md)",
            cursor: "pointer",
            fontSize: "13px",
            color: "#333",
          }}
        >
          Generar nuevo QR
        </button>
      )}
      <div
        style={{ marginTop: "15px", fontSize: "13px", color: "#888" }}
      >
        {status === "connecting"
          ? "Estableciendo conexión..."
          : status === "qr_ready"
            ? "Escanea el QR con tu WhatsApp"
            : "Haz click para conectar"}
      </div>
    </div>
  );
}
